<template>
<div class='pagination '>
    <div class="pc-wrap clearfix" >
        <div class="summary-panel">
            共{{total}}条记录，第{{currentPage}}页
        </div>
        
        <div class="pages-panel">
            <a class="common-btn prev-btn" href="javascript:;"  v-on:click='prevPage'  v-show='hasPrevPage'>上一页</a>
            <template v-for="page in pages">
                <span class="ellipsis" v-if='-1 === page'>...</span>
                <a class="common-btn" href="javascript:;"  v-else-if='currentPage != page' v-on:click='currentPage = page'>{{page}}</a>
                <a class="common-btn selected" href="javascript:;"  v-else-if='currentPage == page'>{{page}}</a>
            </template>
            <a class="common-btn next-btn" href="javascript:;"  v-on:click='nextPage' v-show='hasNextPage'>下一页</a>
        </div>
        <div class="jump-panel">
            <input class="jump-textbox" type="text"  v-model="jumpNum"  />
            <a class="common-btn jump-btn" href="javascript:;" v-on:click='jumpPage'>跳转</a>
        </div>
    </div>
</div>
    
</template>
<script>
export default {
    name: 'pagination',
    data (){
        return {
            totalPage: null,
            hasNextPage: null,
            hasPrevPage: null,
            pages: null,
            currentPage: 1,
            jumpNum: null
        }
    },
    props:{
        total: Number,
        parentPage: Number,
        pageSize: Number
    },
    watch:{
        currentPage: function(val){
            this.reset();
            this.$emit('currentPage', this.currentPage);
        },
        parentPage: function(val){
            this.currentPage = val;
            this.reset();
        }
    },
    created: function () {
        this.reset();
    },
    methods:{
        reset: function(){
            this.totalPage = Math.ceil(this.total / this.pageSize);
            this.hasNextPage = !(this.currentPage >= this.totalPage);
            this.hasPrevPage = !(this.currentPage < 2);

            // reset pages
            if (this.totalPage < 6)
            {
                this.pages = [1, 2, 3, 4, 5].slice(0, this.totalPage);
            }
            else if (this.currentPage <= 3)
            {
                this.pages = [1, 2, 3, 4, -1, this.totalPage];
            }
            else if ((this.totalPage - this.currentPage) >= 3)
            {
                this.pages = [1, -1, this.currentPage-1, this.currentPage, this.currentPage+1, -1, this.totalPage];
            }
            else 
            {
                this.pages = [1, -1, this.totalPage-3, this.totalPage-2, this.totalPage-1, this.totalPage];
            }
        },
        nextPage: function(){
            if(this.currentPage < this.totalPage ){
                this.currentPage = this.currentPage + 1;
            }
        },
        prevPage: function(){
            if(this.currentPage > 1 ){
                this.currentPage = this.currentPage -1;
            }
        },
        jumpPage:function(){
            if(this.jumpNum && this.currentPage != parseInt(this.jumpNum)){
                this.currentPage = parseInt(this.jumpNum);
            }
            
        }
    }

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../assets/sass/cmn.scss";
$pageColor: #79b4ea;
$selecColor: #fff;
.pagination 
{
    display: block;
    height: 28px;
    line-height: 28px;
    padding-top: 20px;
    font-size: 0; /* :BUG: 去除inline-block元素间的空隙 */
    text-align: center;
    .pc-wrap {
        display: inline-block;
        font-size: 14px;
    }
    .pages-panel,.summary-panel,.jump-panel {
        
        display: inline-block;
    }
    .summary-panel,.pages-panel{
        
        margin-right: 14px;
    }
    .summary-panel{
        line-height: 35px;
        color: $pageColor;
    }
    .common-btn{
        display: inline-block;
        height: 28px;
        width: 28px;
        margin-right: 4px;
        border-radius: 3px;
        border: 1px solid $pageColor;
        color: $pageColor;
    }
    .selected{
        color: $selecColor;
        background-color: $pageColor;
    }
    .prev-btn,.next-btn{
        width: 62px;
    }
    .jump-btn {
        width: 46px;
    }
    .ellipsis {
        display: inline-block;
        width: 20px;
        text-align: center;
        margin-right: 4px;
        font-size: 20px;
    }
    .jump-textbox {
        margin-right: 8px;
        padding: 0;
        font-size: 14px;
        text-align: center;
        float: left;
        width: 58px;
        height: 28px;
        border-radius: 3px;
        line-height: 28px;
        border: 1px solid $pageColor;
        color: $pageColor;
        border-radius: 3px;
        background: transparent;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue